import React, {useState, useEffect} from 'react';
import {mergeProdutosVendidos, ProdutoObject, ProdutoVendido} from "models/Produto";
import {IonButton, IonIcon, IonItem, IonProgressBar} from "@ionic/react";
import classNames from "classnames";
import ProdutoVendidoItem from "./ProdutoVendidoItem";
import ProdutoVendidoAdd from "./ProdutoVendidoAdd";
import {addCircleOutline} from "ionicons/icons";
import {formatNumber} from "lib/utils";

const filterProdutosDisponiveis = (todos: ProdutoObject[], vendidos: ProdutoVendido[]) => {
  let lookup: any = {};
  todos.forEach(i => {
    lookup[i.sku] = false;
  })
  vendidos.forEach(i => {
    lookup[i.sku] = true;
  });

  return todos.filter(i => !lookup[i.sku]);
}

interface ProdutoVendidoInputProps {
  produtos: ProdutoObject[];
  produtosVendidos: ProdutoVendido[];
  setProdutosVendidos: (produtos: ProdutoVendido[]) => void;
  disabled?: boolean;
  hasError?: boolean;
  label: string;
  required?: boolean;
  loading?: boolean;
}

const ProdutoVendidoInput: React.FC<ProdutoVendidoInputProps> = (props) => {
  const {hasError, label, required, produtosVendidos, setProdutosVendidos, produtos, loading} = props;
  const [produtosDisponiveis, setProdutosDisponiveis] = useState<ProdutoObject[]>([]);
  const [addIsOpen, setAddIsOpen] = useState(false);
  const [totalVendidos, setTotalVendidos] = useState<number|undefined>();

  // refilter
  useEffect(() => {
    if (produtos.length > 0) {
      setProdutosDisponiveis(filterProdutosDisponiveis(produtos, produtosVendidos));
    }
  }, [produtos, produtosVendidos]);

  // update total produtos vendidos
  useEffect(() => {
    if (!!produtosVendidos.length) {
      let total = 0;
      produtosVendidos.forEach(i => {
        total += i.quantidade * i.valor!;
      });
      setTotalVendidos(total);
    } else {
      setTotalVendidos(undefined);
    }
  }, [produtosVendidos]);

  const onChangeProdutosVendidos = (produto: ProdutoVendido) => {
    const novosProdutos = produtosVendidos.filter(i => i.sku !== produto.sku);
    novosProdutos.push(produto);
    setProdutosVendidos(novosProdutos);
    setAddIsOpen(false);
  }

  const onRemoveProdutoVendido = (produto: ProdutoVendido) => {
    setProdutosVendidos(produtosVendidos.filter(i => i.sku !== produto.sku));
  }

  const onClickAdicionar = () => {
    setAddIsOpen(true);
  }

  return (
    <IonItem>
      {loading &&
        <IonProgressBar type="indeterminate"/>
      }
      {!loading && !!produtos.length &&
        <>
          <div className="w-full my-3">
            <div className={classNames({'text-red-600': hasError}, "text-xs")}>
              {label} {required && '*'}
            </div>
            <div className="w-full mt-2">
              {produtosVendidos.length > 0 &&
                <div className="flex flex-col gap-2">
                  {mergeProdutosVendidos(produtos, produtosVendidos).map(produto => (
                    <ProdutoVendidoItem
                      key={produto.sku}
                      produto={produto}
                      onRemove={() => onRemoveProdutoVendido(produto)}
                    />
                  ))}
                  <div className="flex gap-2 text-xs w-full items-center">
                    <div className="font-bold w-2/12">
                      Total:
                    </div>
                    <div className='flex items-baseline w-10/12'>
                      <div className="text-right w-10/12">
                        R$ {formatNumber(totalVendidos)}
                      </div>
                      <div className='w-2/12'></div>
                    </div>
                  </div>
                </div>
              }

              <div className="mt-2">
                <IonButton
                  size="small"
                  onClick={onClickAdicionar}
                  fill="outline"
                  disabled={produtosDisponiveis.length === 0}
                >
                  <IonIcon slot="start" icon={addCircleOutline}/>
                  Adicionar
                </IonButton>
              </div>
            </div>
          </div>

          <ProdutoVendidoAdd
            produtos={produtosDisponiveis}
            isOpen={addIsOpen}
            onDidDismiss={() => setAddIsOpen(false)}
            onCommit={onChangeProdutosVendidos}
          />
        </>
      }
    </IonItem>
  );
}

export default ProdutoVendidoInput;
